var classSticky = 'sticky';
var lpHeroButton = document.querySelector('#pdpvariants');
var lpStickyCtaBar = document.querySelector('.c-sticky-cta');
var lpFooter = document.querySelector('.b-footer');
var isInViewport = function (elem) {
  var rect = elem.getBoundingClientRect();

  return (
    rect.bottom >= 0
    && rect.right >= 0
    && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    && rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

var timer;
window.addEventListener('scroll', function () {
  if (timer) {
    window.clearTimeout(timer);
  }

  timer = window.setTimeout(function () {
    if (isInViewport(lpHeroButton) || isInViewport(lpFooter)) {
      if (lpStickyCtaBar.classList.contains(classSticky)) {
        lpStickyCtaBar.classList.remove(classSticky)
      }
    } else {
      if (!lpStickyCtaBar.classList.contains(classSticky)) {
        lpStickyCtaBar.classList.add(classSticky)
      }
    }
  }, 1);
});

document.addEventListener('DOMContentLoaded', function () {
  let stickyTitle = document.querySelector('[data-sticky-title]');
  let stickyImage = document.querySelector('[data-sticky-image]');
  let stickySize = document.querySelector('[data-sticky-size]');
  let stickyPrice = document.querySelector('[data-sticky-price]');
  let skioContainer = document.querySelector('.skio-group-container--selected');
  let variantPrice = document.querySelector('.skio-group-container--selected [skio-current-price]');
  let skioSelect = document.querySelectorAll('.skio-group-input');
  let quantitySelect = document.querySelector('input.quantity__input');
  let variantsradios = document.querySelector('#variant-radios');
  let sizeContainer = document.querySelector('[data-size-options]');

  if (skioContainer && skioContainer.classList.contains("skio-group-container--subscription")){
    setTimeout(function () {
      stickyPrice.innerHTML = variantPrice.innerHTML;
    }, 500);
  }

  if (skioSelect) {
    skioSelect.forEach(function (e) {
      e.addEventListener('change', function () {
        let variantPrice = e.closest('[skio-group-container]').querySelector('[skio-current-price]');
        setTimeout(function () {
          stickyPrice.innerHTML = variantPrice.innerHTML;
        }, 100)
      });
    })
  }

  if (variantsradios) {
    variantsradios.addEventListener('click', function (e) {
      let selectedOption = e.target.closest('[data-product-option]');
      let variantPrice = document.querySelector('.skio-group-container--selected [skio-current-price]');

      if (selectedOption?.classList?.contains('size-options')) {
        setTimeout(function () {
          stickySize.innerHTML = selectedOption.dataset.variant;
          stickyPrice.innerHTML = variantPrice.innerHTML;
        }, 100)
      } else {
        let flavorTitle = selectedOption.querySelector('.flavor-title').innerHTML;
        let flavorImage = selectedOption.querySelector('.variant-img-wrapper').innerHTML;
        if (stickyTitle) {
          stickyTitle.innerHTML = flavorTitle;
        }
        if (flavorImage) {
          stickyImage.innerHTML = flavorImage;
        }

        sizeContainer.addEventListener("size-options-change", () => {
          let currentVariantSize = document.querySelector('[data-size-option-item]:checked');
          stickySize.innerHTML = currentVariantSize.value;
        })

        setTimeout(function () {
          stickyPrice.innerHTML = variantPrice.innerHTML;
        }, 100)
      }
    });
  }

  // Clicking a flavor swatch re-renders the product section without a full page
  // reload, which repaints the sticky bar with the server-rendered single-unit
  // price (e.g. $24.99) instead of the selected pack/plan price (e.g. $39.98).
  // Mirror the currently selected Skio price and active pack into the sticky bar
  // on any DOM change so it always matches the main selector.
  function syncStickyBar() {
    var selectedPrice = document.querySelector('.skio-group-container--selected [skio-current-price]');
    var priceEl = document.querySelector('[data-sticky-price]');
    if (selectedPrice && priceEl) {
      var priceText = selectedPrice.textContent.trim();
      if (priceText && priceEl.textContent.trim() !== priceText) {
        priceEl.textContent = priceText;
      }
    }
    var activePack = document.querySelector('quantity-input-buttons .quantity-button.active');
    var sizeEl = document.querySelector('[data-sticky-size]');
    if (activePack && sizeEl && activePack.dataset.name && sizeEl.textContent.trim() !== activePack.dataset.name) {
      sizeEl.textContent = activePack.dataset.name;
    }
  }

  var stickySyncScheduled = false;
  var stickyObserver = new MutationObserver(function () {
    if (stickySyncScheduled) return;
    stickySyncScheduled = true;
    requestAnimationFrame(function () {
      stickySyncScheduled = false;
      syncStickyBar();
    });
  });
  stickyObserver.observe(document.body, { subtree: true, childList: true, characterData: true });
  syncStickyBar();
});
